/**
 * 選択された連絡手段によって入力欄を切り替える.
 *
 * @returns {void}
 */
const toggleInfoField = (): void => {
    const methodSelect = document.querySelector<HTMLSelectElement>(
        ".js-shipping-contact-method"
    );
    const infoWrap = document.querySelector<HTMLElement>(
        ".js-shipping-contact-info-wrap"
    );

    if (!methodSelect || !infoWrap) return;

    const infoInput = infoWrap.querySelector<HTMLInputElement>("input");

    if (!infoInput) return;

    const showValues: string[] = JSON.parse(
        methodSelect.dataset.showContactInfoValues ?? "[]"
    ).map(String);

    const updateShippingContact = () => {
        const method = methodSelect.value;

        if (showValues.includes(method)) {
            infoWrap.style.display = "";
            infoInput.disabled = false;
        } else {
            infoInput.value = "";
            infoInput.disabled = true;
            infoWrap.style.display = "none";
        }
    };

    methodSelect.addEventListener("change", updateShippingContact);

    // 初期表示（戻る／バリデーションエラー対応）
    updateShippingContact();
};

export { toggleInfoField };
